export enum StatusPreenchimento {
  PENDENTE = 'PENDENTE',
  ENVIADO = 'ENVIADO',
  APROVADO = 'APROVADO',
  ALTERACAO_NECESSARIA = 'ALTERACAO_NECESSARIA',
  JUSTIFICADO = 'JUSTIFICADO'
}
